<template>
  <div class="main">
    <tree :router="router"></tree>
  </div>
</template>

<script>
const menu = [
  {
    name: "About",
    path: "/about",
    children: [
      {
        name: "About US",
        path: "/about/us"
      },
      {
        name: "About Comp",
        path: "/about/company",
        children: [
          {
            name: "About Comp A",
            path: "/about/company/A",
            children: [
              {
                name: "About Comp A 1",
                path: "/about/company/A/1"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    name: "Link",
    path: "/link"
  }
];
import Tree from "../../components/Tree";

export default {
  name: "home",
  components: {
    Tree
  },
  data() {
    return {
      router: menu // ... 省略菜单数据
    };
  }
};
</script>

<style scoped>
.main {
  position: absolute;
  top: 60px;
  left: 20px;
  right: 20px;
  bottom: 20px;
  overflow-y: auto;
  padding: 20px;
  background-color: #fff;
}
.draggable-tree >>> .ant-tree-title {
  font-size: 16px;
}
.draggable-tree >>> li {
  line-height: 32px;
}
.draggable-tree >>> i {
  color: #8a8a8a;
  font-size: 18px;
}
</style>
